import { ContentBody } from "@app/components/core/ContentBody/ContentBody"
import { ContentHeader } from "@app/components/core/ContentHeader/ContentHeader"
import Button from "@app/components/move2Library/Button/Button"
import Input from "@app/components/move2Library/Input/Input"
import { useCustomNavigation } from "@app/components/navigation/NavigationHandler"
import ImagePage from "@app/components/pageTypes/ImagePage/ImagePage"
import AnimatedRoute, { AnimationTypes } from "@app/components/routing/AnimatedRoute/AnimatedRoute"
import { useRaiseError } from "@app/store/actions/errorActions"
import { useGetStrings } from "@app/store/service/cmsService"
import { useResetPassword } from "@app/store/service/connectorService"
import { emailPattern } from "@app/utils/validations"
import { useViewport } from "@tecreation/funnel-components"
import { useCallback } from "react"
import { useForm } from "react-hook-form"

const ForgotPasswordPage = () => {
	const { replace } = useCustomNavigation()
	const { sm, md } = useViewport()
	const raiseError = useRaiseError()

	const {
		data: { forgotPasswordPageSubTitle, buttonResetPassword, labelEmail, errorInputMissingEmail, errorInputInvalidEmail },
	} = useGetStrings(undefined, { defaultData: {} })
	const [resetPassword] = useResetPassword()

	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm({
		mode: "onSubmit",
		defaultValues: {
			email: "",
		},
	})

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const submit = useCallback(async () => {
		handleSubmit(async data => {
			try {
				let result = await resetPassword({ email: data.email }).unwrap()
				result && replace("/login?action=forgotPassword", AnimationTypes.stack, {}, "POP")
			} catch (e) {
				raiseError(e)
			}
		})()
	})

	return (
		<AnimatedRoute className="h-100">
			<ImagePage>
				<ContentHeader canGoBack colorStyle="white" animation={AnimationTypes.slide}>
					{forgotPasswordPageSubTitle}
				</ContentHeader>
				<ContentBody className="container-md f4 mt-6">
					<Input
						name="email"
						type="email"
						label={labelEmail}
						formRegister={register("email", {
							required: {
								value: true,
								message: errorInputMissingEmail,
							},
							pattern: {
								value: emailPattern,
								message: errorInputInvalidEmail,
							},
						})}
						className="primary"
						errors={errors}
					/>
					<div className={"mt-4" + (sm || md ? " flex" : "")}>
						<Button style="primary" onClick={submit} fillWidth={sm || md}>
							{buttonResetPassword}
						</Button>
					</div>
				</ContentBody>
			</ImagePage>
		</AnimatedRoute>
	)
}

export default ForgotPasswordPage
